export function _pushHash(hash) {
  history.pushState(null, "", window.location.pathname + hash);
}

export function _replaceHash(hash) {
  history.replaceState(null, "", window.location.pathname + hash);
}
